import { homeRoutes } from '@/Home/home.routes';
const homeModule = {
    routes: homeRoutes
};
export default homeModule;
